import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';
import { getAssetPath } from '@/utils';

interface ExploreButtonProps {
  onClick: () => void;
}

const ExploreButton: React.FC<ExploreButtonProps> = ({ onClick }) => {
  const { t } = useLanguage();
  const clickIcon = getAssetPath('assets/click.png');

  return (
    <motion.button
      animate={{
        y: [0, -12, 0, -8, 0],
        scale: [1, 1.12, 1, 1.08, 1],
        rotate: [0, -2, 2, -1, 0],
        boxShadow: [
          '0 4px 12px rgba(28, 63, 117, 0.4), 0 2px 8px rgba(0, 0, 0, 0.3)',
          '0 6px 18px rgba(135, 206, 250, 0.6), 0 3px 10px rgba(0, 0, 0, 0.4)',
        ],
        backgroundColor: ['rgba(28, 63, 117, 0.9)', 'rgba(135, 206, 250, 0.95)'],
      }}
      whileHover={{
        scale: 1.2,
        y: -8,
        rotate: 0,
      }}
      whileTap={{
        scale: 0.95,
      }}
      transition={{
        duration: 1.8,
        repeat: Infinity,
        ease: 'easeInOut',
        repeatDelay: 0.2,
        backgroundColor: { duration: 0.6, repeat: Infinity, repeatType: 'reverse', ease: 'easeInOut' },
        boxShadow: { duration: 0.6, repeat: Infinity, repeatType: 'reverse', ease: 'easeInOut' },
        scale: { duration: 0.1 },
      }}
      onClick={onClick}
      className="mt-auto inline-flex items-center justify-center px-6 py-3 rounded-full transition-all duration-300 border border-white/5 backdrop-blur-md font-['Montserrat',sans-serif] text-[18px] font-bold text-white w-full relative overflow-hidden"
      style={{
        position: 'relative',
        backgroundColor: 'rgba(28, 63, 117, 0.9)',
      }}
    >
      <motion.span
        animate={{
          opacity: [0.8, 1, 0.8],
          scale: [1, 1.05, 1],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        style={{
          position: 'relative',
          zIndex: 1,
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5), 1px 1px 2px rgba(0, 0, 0, 0.7)',
        }}
      >
        <span className="flex items-center justify-center gap-2" style={{ position: 'relative', zIndex: 1 }}>
          <img
            src={clickIcon}
            alt=""
            style={{
              width: '36px',
              height: '36px',
              flexShrink: 0,
              objectFit: 'contain',
            }}
            aria-hidden="true"
          />
          <span>{t('explore')}</span>
        </span>
      </motion.span>
      <motion.div
        className="absolute inset-0 rounded-full"
        animate={{
          background: [
            'radial-gradient(circle at 50% 50%, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 100%)',
            'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 70%)',
            'radial-gradient(circle at 50% 50%, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 100%)',
          ],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        style={{ pointerEvents: 'none' }}
      />
    </motion.button>
  );
};

export default ExploreButton;
